export const SEARCH_PARAMS_KEYS = {
  set: 'set',
  reset: 'reset',
  passwordChangeType: 'passwordChangeType',
  context: 'context',
  token: 'token',
  setPasswordType: 'setPasswordType',
  caseId: 'caseId',
  activeClaimItemId: 'activeClaimItemId',
  siteProofId: 'siteProofId',
  activeTab: 'activeTab',
  officeId: 'officeId',
  iaId: 'iaId'
};

export const PAGE_URLS = {
  iaDetailPage: '/issuing-authority-map/#{issuingAuthorityId}',
  forgotPassword: '/onboarding/forgot-password',
  setPassword: '/onboarding/set-password',
  resetPassword: '/onboarding/reset-password',
  aboutYourself: '/onboarding/about-yourself',
  passwordChanged: '/onboarding/password-changed?type=#{type}',
  onBoardinSignin: '/onboarding/log-in',
  siteVerificationDashboard: '/dashboard/site-verification',
  otherVerificationDashboard: '/dashboard/other-verification',
  teamMembers: '/dashboard/team-members',
  profile: '/dashboard/profile',
  iaCreation: '/issuing-authority-map?caseId=#{caseId}',
  iaCreationBaseUrl: '/issuing-authority-map',
  verifyBulkDetailsBaseUrl: '/verify-details',
  verifyBulkDetails:
    '/verify-details?claimItemId=#{claimItemId}&caseId=#{caseId}',
  iaResearch: '/issuing-authority-map?officeId=#{issuingAuthorityOfficeId}',
  iaClaimVerificationBaseUrl: '/ia-claim-verification',
  iaClaimVerification: '/ia-claim-verification?caseId=#{caseId}'
};
export const DASHBOARD_URLS = {
  verification: `/dashboard/verification`,
  siteVerificationDashboard: '/dashboard/site-verification',
  iaCreation: '/dashboard/ia-creation',
  iaResearch: '/dashboard/ia-research'
};

export const NON_LOGGED_IN_PAGE_URLS = [
  PAGE_URLS.onBoardinSignin,
  PAGE_URLS.forgotPassword,
  PAGE_URLS.passwordChanged,
  PAGE_URLS.setPassword,
  PAGE_URLS.resetPassword,
  PAGE_URLS.aboutYourself
];

export const NOTIFICATIONS_URLS = {
  home: '/notifications',
  noNotificationImgPath: '/assets/image/amico.png'
};

export const COUNTRY_CODE = 'countryCode';

export const COUNTRY_FLAG_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/country/#{${COUNTRY_CODE}}.svg`;

export const EMPTY_SCREEN_IMAGE_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/no_documents.png`;

export const VALID_FILE_TYPES = ['PNG', 'JPG', 'PDF'];

export const DATAFLOW_LOGO_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/dataflowVerificationPartnerLogo.png`;
